import {
  Heading,
  VStack,
  Button,
  Flex,
} from '@chakra-ui/react';
import React, { useCallback, useEffect } from 'react';
import usePackageStore from '../../../../store/packageStore';
import { getPackages } from '../../../../api/packages';
import { useNavigate } from 'react-router-dom';
import { PackageCard } from '../../../Landing/Packages/PackageCard';

export const MostSearchPackages = () => {
  const { packages, setPackages } = usePackageStore();
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    try {
      const res = await getPackages();
      setPackages(res);
    } catch (error) {
      console.error('error while loading most searched packages', error);
    }
  }, [setPackages]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <VStack p={[7, 10]} spacing={12}>
      <Flex flexDir={'column'} gap={[5, 9]} alignItems={'center'}>
        <Heading color="teal" fontSize={[24, 30]}>
          Health Checkup Packages
        </Heading>
      </Flex>
      <VStack
        spacing={[6, 8]}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto auto',
          justifyContent: 'center',
        }}
      >
        {packages.slice(0, 2).map((pkg, i) => (
          <PackageCard key={pkg._id || i} packages={pkg} />
        ))}
      </VStack>
      <Button
        variant={'ghost'}
        color={'teal'}
        onClick={() => navigate('/packages')}
      >
        All Packages
      </Button>
    </VStack>
  );
};
